import { useMe } from "@/lib/graphql/me"
import type { MeUserPermission } from "@/lib/graphql/me"

type UseUserPermissionReturn = {
	refetch: () => void
	userPermission?: MeUserPermission
}

export const useUserPermission = (): UseUserPermissionReturn => {
	const { refetch, salon } = useMe()
	return {
		refetch,
		userPermission: salon?.userPermission,
	}
}
